<div class="notification-body">
  <p>{{ 'TGA.Notifications.QuestionnaireNotCompleted.Description' | translate }}</p>
</div>
